/* eslint-disable */
/**
 * Google Analytics 3 is deprecated on 7/1/2024
 */

// Google analytics debugger:
// https://chrome.google.com/webstore/detail/google-analytics-debugger/jnkmfdileelhofjcijamephohjechhna

import {curry} from 'ramda';

import settings from './settings.json';
const {gaTimeout} = settings;

//Recursively check for Google Analyti dcs to load
const checkGA = (res, rej, maxWait) => {
    return res(() => null); // forced early exist for ga3 deprecation

    if (Date.now() > maxWait) {
        rej(new Error('Google Analytics Timeout'));
    } else if (window.ga) {
        res(window.ga);
    } else {
        setTimeout(() => checkGA(res, rej, maxWait), 500);
    }
};

// removes properties with a value of undefined from an object
const excludeUndef = obj =>
    Object.keys(obj).reduce((o, k) => {
        if (o[k] === undefined) {
            delete o[k];
        }
        return o;
    }, obj);

// Exposed global promise for accessing google analytics
export const GAPromise = new Promise((res, rej) => {
    checkGA(res, rej, Date.now() + gaTimeout);
}).catch(err => console.log(err.message));

// Exported for testing
export const _sendError = curry(({message, source, isFatal}, ga) =>
    ga(
        'send',
        'exception',
        excludeUndef({
            exDescription: source ? `${source}: ${message}` : `${message} url: ${window.location.href}`,
            exFatal: isFatal === undefined ? undefined : !!isFatal,
        }),
    ),
);

// Helper to log an exception to google analytics
// Usage
// logError({
//   'message': `Preview failed to load: ${err}`,
//   'isFatal': true // pass true if you know that the error damages the user experience
// })
// GA docs https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
export const logError = ({message, isFatal}) => GAPromise.then(_sendError({message, isFatal}));

// Exported for testing
export const _windowOnError = (message, source) => GAPromise.then(_sendError({message, source}));

// This should only be run once for the entire application but multiple calls shouldn't hurt anything
export const logErrors = () => {
    window.onerror = _windowOnError;
};

// Exported for testing
export const _sendPageviews = curry(({page, title, location}, ga) =>
    ga(
        'send',
        excludeUndef({
            hitType: 'pageview',
            page,
            title,
            location,
        }),
    ),
);

// Helper to log an pageview to google analytics
// Usage
// logPageview({
//   page: '#/stories/new',
//   title: 'New Story'
// })
export const logPageview = ({page, title, location}) => GAPromise.then(_sendPageviews({page, title, location}));

// exported for testing
export const _sendEvents = curry(({category, action, label, value}, ga) =>
    ga(
        'send',
        excludeUndef({
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value,
        }),
    ),
);

// Helper to log an event to google analytics
// Usage
// logEvent({
//   category: 'CoolEvents',
//   action: 'started',
//   label: 'party at my house'
// })
// GA docs https://developers.google.com/analytics/devguides/collection/analyticsjs/events
export const logEvent = ({category, action, label, value}) =>
    GAPromise.then(_sendEvents({category, action, label, value}));
